import RESTAdapter from '@ember-data/adapter/rest';

import { registerBaseURL } from 'register-partners-js/constants/hosts';

export default class RegisterDocumentAdapter extends RESTAdapter {
  host = registerBaseURL;
  namespace = 'v1';

  pathForType() {
    return 'documents';
  }

  ajaxOptions() {
    let options = super.ajaxOptions(...arguments);
    options.credentials = 'include';

    return options;
  }
}
